@if (!renewal.isHiddenByStatus() && renewal.titleLabelKey(); as titleKey) {
  <div
    class="plan-renewal-card d-flex"
    [class.plan-renewal-card--compact]="renewal.context() === 'MyPlan'"
    [class.plan-renewal-card--expired]="renewal.isExpired()"
    role="status"
    aria-live="polite"
    aria-atomic="true"
    [style.--notice-border-color]="renewal.borderColor()"
    [style.--notice-icon-color]="renewal.iconColor()"
    [style.--notice-bubble-color]="renewal.bubbleColor()"
    [style.--notice-cta-color]="renewal.buttonColor()"
  >
    <div class="plan-renewal-card__content">
      @if (renewal.bubbleLabelKey(); as bubbleKey) {
        <div class="plan-renewal-card__bubble">
          <app-adp-label-dynamic class="paragraph-body-m-semi" [labelKey]="bubbleKey" [context]="renewal.labelContext()"></app-adp-label-dynamic>
        </div>
      }
      <div class="plan-renewal-card__heading d-flex align-items-start header-semi-l">
        <mat-icon aria-hidden="true" class="plan-renewal-card__icon d-flex align-items-center justify-content-center" [svgIcon]="renewal.iconName()"></mat-icon>
        <app-adp-label-dynamic [labelKey]="titleKey" [context]="renewal.labelContext()"></app-adp-label-dynamic>
      </div>
      @if (renewal.bodyLabelKey(); as bodyKey) {
        <div class="plan-renewal-card__body paragraph-body-l-reg">
          <app-adp-label-dynamic [labelKey]="bodyKey" [context]="renewal.labelContext()"></app-adp-label-dynamic>
        </div>
      }
    </div>
    <button
      class="plan-renewal-card__cta"
      mat-flat-button
      color="accent"
      [sf-aria-label]="renewal.buttonAriaKey()"
      (click)="onRenewClick()"
      [gtmClick]="getResourceViewLabel(renewal.buttonLabelKey())"
      gtmLinkURL="/renew"
    >
      <div class="d-flex align-items-center">
        <app-adp-label-dynamic [labelKey]="renewal.buttonLabelKey()" [context]="renewal.labelContext()"></app-adp-label-dynamic>
        <mat-icon aria-hidden="true" class="d-flex align-items-center" svgIcon="chevron-right-blue"></mat-icon>
      </div>
    </button>
  </div>
}
